import {handleActions} from 'redux-actions';
import {List, Map, OrderedMap} from 'immutable';

import * as TagActions from 'web-app/react/entities/tags/actions';
import * as GroupActions from 'web-app/react/entities/groups/actions';

import Institution from './model';
import * as Actions from './actions';
import * as TypedActions from './typed-actions';
import * as EmployeeActions from '../employees/actions';

const updateInstitutionInformation = (institutions, newInstitutionId, updateFunc) => {
    return institutions.update(newInstitutionId, Institution.default, updateFunc);
};

export default handleActions(
    {
        [Actions.fetchAllSuccess.type]: (state, {payload}) => {
            const institutionMap = OrderedMap(payload.institutions.map(inst => [inst.institutionId, inst]));
            return state.merge(institutionMap);
        },

        [TypedActions.fetchBehaviorsSuccess.type]: (state, {payload}) => {
            return updateInstitutionInformation(state, payload.institutionId, inst =>
                inst.merge({behaviors: payload.behaviors}),
            );
        },

        [Actions.updateSuccess.type]: (state, {payload}) =>
            updateInstitutionInformation(state, payload.institution.institutionId, inst => {
                return inst.merge(payload.institution).merge({
                    openingHoursBehaviors: inst.openingHoursBehaviors,
                    openingHours: inst.openingHours,
                });
            }),
        [Actions.fetchOpeningHours.type]: (state, {payload}) =>
            updateInstitutionInformation(state, payload.institutionId, inst =>
                inst.merge({
                    fetchingOpeningHours: true,
                }),
            ),

        [Actions.fetchOpeningHoursSuccess.type]: (state, {payload}) =>
            updateInstitutionInformation(state, payload.institutionId, inst =>
                inst.merge({
                    openingHours: payload.openingHours,
                    openingHoursBehaviors: payload.behaviors,
                    fetchingOpeningHours: false,
                }),
            ),

        [Actions.fetchOpeningHoursFailed.type]: (state, {payload}) =>
            updateInstitutionInformation(state, payload.institutionId, inst =>
                inst.merge({
                    fetchingOpeningHours: false,
                }),
            ),

        [Actions.updateOpeningHours.type]: (state, {payload}) =>
            updateInstitutionInformation(state, payload.institutionId, inst =>
                inst.merge({
                    updatingOpeningHours: true,
                }),
            ),

        [Actions.updateOpeningHoursSuccess.type]: (state, {payload}) =>
            updateInstitutionInformation(state, payload.institutionId, inst =>
                inst.merge({
                    openingHours: payload.openingHours,
                    updatingOpeningHours: false,
                }),
            ),

        [Actions.updateOpeningHoursFailed.type]: (state, {payload}) =>
            updateInstitutionInformation(state, payload.institutionId, inst =>
                inst.merge({
                    updatingOpeningHours: false,
                }),
            ),

        [Actions.fetchGroups.type]: (state, {payload}) =>
            updateInstitutionInformation(state, payload.institutionId, inst =>
                inst.merge({
                    fetchingGroups: true,
                }),
            ),

        [Actions.fetchGroupsSuccess.type]: (state, {payload}) =>
            updateInstitutionInformation(state, payload.institutionId, inst =>
                inst.merge({
                    allGroups: payload.groups,
                    fetchingGroups: false,
                    didFetchGroups: true,
                }),
            ),

        [Actions.fetchGroupsFailed.type]: (state, {payload}) =>
            updateInstitutionInformation(state, payload.institutionId, inst =>
                inst.merge({
                    fetchingGroups: false,
                }),
            ),

        [TagActions.fetchAllSuccess.type]: (state, {payload}) =>
            updateInstitutionInformation(state, payload.institutionId, inst =>
                inst.merge({
                    tagIds: payload.tags.map(tag => tag.tagId),
                }),
            ),

        [GroupActions.fetchAll.type]: (state, {payload}) =>
            updateInstitutionInformation(state, payload.institutionId, inst =>
                inst.merge({
                    fetchingGroups: true,
                }),
            ),

        [GroupActions.fetchAllSuccess.type]: (state, {payload}) =>
            updateInstitutionInformation(state, payload.institutionId, inst =>
                inst.merge({
                    groupIds: payload.groups.map(c => c.groupId),
                    fetchingGroups: false,
                }),
            ),

        [EmployeeActions.fetchAllEmployeesSuccess.type]: (state, {payload}) =>
            updateInstitutionInformation(state, payload.institutionId, inst =>
                inst.merge({
                    employeeIds: List(payload.employees).map(c => c.employeeId),
                }),
            ),
    },
    Map(),
);
